import { AskAiRoute } from "./AskAiRoute";

export const AskAiRoutes = [
  {
    path: "askai",
    element: <AskAiRoute />,
  },
];
